import { Repository } from "src/firebase/firestore/repository";
import { Session } from "./types/session.entity";
import { getDocs, limit, query, where } from "firebase/firestore";
import { FilterQuery } from "src/firebase/firestore/types";

export class SessionRepository extends Repository<Session> {
  constructor() {
    super("sessions");
  }
  async findSessionByBookingId(bookingId: string) {
    const q = query(this.collection, where("bookingIds", "array-contains", bookingId), limit(1));

    const snapshot = await getDocs(q);

    if (snapshot.empty) return undefined;

    const doc = snapshot.docs[0];

    return this.map(doc);
  }
}

export const sessionRepository = new SessionRepository();
